import { render, staticRenderFns } from "./EnablebatchesOld.vue?vue&type=template&id=67d64ef1"
import script from "./EnablebatchesOld.vue?vue&type=script&lang=js"
export * from "./EnablebatchesOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports